import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "../../../assets/css/customer/customerauth/CustomerLogin.css";
import { useBaseUrl } from "../../../context/AppContext";

const CustomerLogin = () => {
  const navigate = useNavigate();
  const { baseUrl } = useBaseUrl();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // =========================
  // AUTO LOGIN
  // =========================
  useEffect(() => {
    const customerEmail = localStorage.getItem("customerEmail");
    const customerPassword = localStorage.getItem("customerPassword");

    if (customerEmail && customerPassword) {
      customerAutoLogin(customerEmail, customerPassword);
    }
  }, []);

  const customerAutoLogin = (customerEmail, customerPassword) => {
    setIsLoading(true);
    setError("");

    const formdata = new FormData();

    formdata.append("email", customerEmail);
    formdata.append("password", customerPassword);

    axios
      .post(
        `${baseUrl}/customer/auth/customer-login`,
        formdata
      )
      .then((response) => {
        console.log("AUTO LOGIN RESPONSE:", response.data);

        if (response.data.customer) {
          const customer = response.data.customer;

          // Save complete customer data
          localStorage.setItem(
            "customerData",
            JSON.stringify(customer)
          );

          localStorage.setItem(
            "customer",
            JSON.stringify(customer)
          );

          localStorage.setItem(
            "customerId",
            customer.id
          );

          localStorage.setItem(
            "customerEmail",
            customer.email
          );

          navigate("/customer/dashboard");
        } else {
          // Invalid old credentials
          localStorage.removeItem("customerEmail");
          localStorage.removeItem("customerPassword");
          localStorage.removeItem("customer");
          localStorage.removeItem("customerData");

          setError("Invalid email or password.");
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log("AUTO LOGIN ERROR:", error);

        setIsLoading(false);

        setError(
          error.response?.data?.message ||
          "Something went wrong!"
        );
      });
  };

  // =========================
  // NORMAL LOGIN
  // =========================
  const handleLogin = (e) => {
    e.preventDefault();

    setError("");

    if (!email.trim() || !password.trim()) {
      setError("Please enter email and password.");
      return;
    }

    setIsLoading(true);

    const formdata = new FormData();

    formdata.append("email", email);
    formdata.append("password", password);

    axios
      .post(
        `${baseUrl}/customer/auth/customer-login`,
        formdata
      )
      .then((response) => {
        console.log("LOGIN RESPONSE:", response.data);

        if (response.data.customer) {
          const customer = response.data.customer;

          // Save complete customer data
          localStorage.setItem(
            "customerData",
            JSON.stringify(customer)
          );

          // Keep customer key also
          localStorage.setItem(
            "customer",
            JSON.stringify(customer)
          );

          localStorage.setItem(
            "customerId",
            customer.id
          );

          localStorage.setItem(
            "customerEmail",
            customer.email
          );

          localStorage.setItem(
            "customerPassword",
            password
          );

          navigate("/customer/dashboard");
        } else {
          setError(
            response.data.error ||
            response.data.message ||
            "Invalid email or password."
          );
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log("LOGIN ERROR:", error);

        setError(
          error.response?.data?.message ||
          "Something went wrong!"
        );

        setIsLoading(false);
      });
  };

  return (
    <div className="sgc-login-page">

      <Container fluid className="p-0">

        <Row className="justify-content-center m-0">

          <Col xs={12} className="p-0">

            <div className="sgc-login-card mx-auto">

              <div className="sgc-login-brand">

                <div className="sgc-login-brand-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
                  </svg>
                </div>

                <p className="sgc-login-brand-name">
                  Estetica skin&laser
                </p>

              </div>

              <h1 className="sgc-login-heading">
                Customer sign in
              </h1>

              <p className="sgc-login-subtext">
                Access your appointments, treatments and offers.
              </p>

              {error && (
                <Alert variant="danger">
                  {error}
                </Alert>
              )}

              <form onSubmit={handleLogin}>

                <div className="sgc-login-form-group">

                  <label>Email</label>

                  <input
                    type="email"
                    className="sgc-login-input"
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value)
                    }
                  />

                </div>

                <div className="sgc-login-form-group">

                  <label>Password</label>

                  <input
                    type="password"
                    className="sgc-login-input"
                    value={password}
                    onChange={(e) =>
                      setPassword(e.target.value)
                    }
                  />

                </div>

                <button
                  type="submit"
                  className="sgc-login-btn-primary d-flex align-items-center justify-content-center gap-2"
                  disabled={isLoading}
                >

                  {isLoading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />

                      <span>
                        Signing in...
                      </span>
                    </>
                  ) : (
                    "Sign in"
                  )}

                </button>

              </form>

              <div className="sgc-login-footer">

                <p>
                  New here?{" "}

                  <Link
                    to="/customer/register"
                    className="sgc-login-link"
                  >
                    Create an account
                  </Link>
                </p>

              </div>

            </div>

          </Col>

        </Row>

      </Container>

    </div>
  );
};

export default CustomerLogin;